import {
	BREAKPOINTS_OPTIONS,
	ERROR_COLOR,
	PRIMARY_COLOR,
	SPACING,
	SUCCESS_COLOR,
} from '@constants/themes.constants';
import { createTheme } from '@mui/material';

const TEXT_COLOR = '#000000DE';

const filtersTheme = createTheme({
	breakpoints: BREAKPOINTS_OPTIONS,
	components: {
		MuiButton: {
			styleOverrides: {
				contained: {
					boxShadow: 'none',
				},
				root: {
					color: TEXT_COLOR,
					fontWeight: 400,
					height: 38,
				},
			},
		},
		MuiFilledInput: {
			styleOverrides: {
				root: {
					borderRadius: 4,
					'&:after, &:before': {
						display: 'none',
					},
				},
				input: {
					paddingTop: 4,
				},
			},
		},
		MuiInputBase: {
			styleOverrides: {
				root: {
					height: 38,
				},
			},
		},
		MuiInputAdornment: {
			styleOverrides: {
				root: {
					marginTop: '0px !important',
				},
			},
		},
	},
	palette: {
		error: ERROR_COLOR,
		info: PRIMARY_COLOR,
		primary: {
			contrastText: TEXT_COLOR,
			main: '#ECECEC',
		},
		secondary: {
			contrastText: TEXT_COLOR,
			main: '#CCCCCC',
		},
		success: SUCCESS_COLOR,
	},
	spacing: SPACING,
});

export default filtersTheme;
